import React from 'react';

import SplitLayout from '../layout-split';

const firstParagraph = "Jacquelyn Moore-Hill’s approach to interior design draws on her multifaceted background, which includes a passion for history, fashion, textiles, and art. While her aesthetic leans toward the clean and modern, with carefully considered doses of color and pattern, she has a broad knowledge and appreciation of myriad styles that date back to the beginning of her career on staff at Elle Decor magazine. Ultimately deciding that rather than writing about interiors, she wanted to create them, Jacquelyn worked for leading architecture and interior design firms Deborah Berke Partners, MR Architecture + Decor, and Christopher Coleman Interior Design. Along the way, she honed her vision of what a home should be: a retreat from the everyday that meets the clients’ needs and reflects their tastes, while still managing to delight and surprise them. With more than 10 years in the interior design industry, she founded her eponymous firm in 2012.";
const secondParagraph = "Based in Brooklyn, N.Y., Jacquelyn Moore Hill Interior Design has developed a reputation for creating bespoke interiors that are driven by aesthetic, functional, and economic goals. Attention to detail is a hallmark of the firm’s work—whether it’s a small-scale renovation that entails producing drawings necessary for construction and assisting with the purchase of key decor items, or an extensive new-construction project that requires working in tandem with architectural and engineering teams. As part of the process of bringing a concept to life, Moore-Hill embraces the creative collaborations forged with vendors as well as clients.";

const About = () => (
  <section className="about">
    <p className="about--intro">{firstParagraph}</p>
    <hr className="about--hr"/>
    <div className="about--details">
      <img src={require ('../../images/about_landscape.png')} 
        className="about--landscape"/>
      <hr className="about--hr"/>
      <SplitLayout className="about--split-layout">
        <div className="about--details-text">
          <p>
            {secondParagraph}
          </p>
        </div>
        <div className="about--portrait-container"> 
          <img src={require ('../../images/about_portrait.png')}
            className="about--portrait"/>
        </div>
      </SplitLayout>
    </div>
  </section>
);

export default About;


// WEBPACK FOOTER //
// ./components/page-about/index.js